import { AssetInventoryDocumentResponse, DocumentResponse } from "@/api";

/**
 * Adapts an asset-inventory document to the DocumentResponse shape the shared document
 * drag & drop pipeline (DragData, pending rows) is built on. Asset-inventory documents are
 * ordinary documents server-side; the response type only differs in its metadata fields.
 */
export function toDocumentResponse(document: AssetInventoryDocumentResponse): DocumentResponse {
  return {
    documentId: document.documentId,
    sourceFileId: document.sourceFileId,
    clientId: document.clientId,
    fileName: document.fileName,
    contentType: document.contentType,
    fileSizeBytes: document.fileSizeBytes,
    assignedAtUtc: document.createdAtUtc,
    assignedByUserCode: document.createdByUserCode,
    isPreviewAvailable: document.isPreviewAvailable,
  };
}
